// :: CURRENT PLAN PAGE RELATED CONSTANTS
import codeconstructionlogo from "../assets/billing-icons/code-construction-logo.png";
import industryconnectlogo from "../assets/billing-icons/industry-conect-logo.png";
import microniclogo from "../assets/billing-icons/micronic-logo.png";
import moglixlogo from "../assets/billing-icons/moglix-logo.png";
import sproutsolutionlogo from "../assets/billing-icons/sprout-solution-logo.png";
import tagnos from "../assets/billing-icons/tagnos.png";

// Billing Plans Defined from BackEnd

export const BILLING_PLANS = {
  ESSENTIALS: "essentials",
  TEAM_MONTHLY: "team-monthly",
  TEAM_ANNUAL: "team-annual",
  ENTERPRISE_MONTHLY: "enterprise-monthly",
  ENTERPRISE_ANNUAL: "enterprise-annual",
  // NEW PLANS INTRODUCED KEY
  BASIC: "basic",
  PRO_PLUS_MONTHLY: "pro-plus-monthly",
  PRO_PLUS_ANNUAL: "pro-plus-annual",
  PRO_MONTHLY: "pro-monthly",
  PRO_ANNUAL: "pro-annual",
  TEAM_ANNUAL_V3: "v3-team-annual",
  TEAM_MONTHLY_V3: "v3-team-monthly",
  ENTERPRISE_ANNUAL_V3: "v3-ent-annual",
  ENTERPRISE_MONTHLY_V3: "v3-ent-monthly",
  BASIC_V3_1: "v3.1-basic",
  BASIC_V3_2: "v3.2-basic",
  BASIC_V3_3: "v3.3-basic",
  PRO_MONTHLY_V3_1: "v3.1-pro-monthly",
  PRO_MONTHLY_V3_2: "v3.2-pro-monthly",
  PRO_MONTHLY_V3_3: "v3.3-pro-monthly",
  PRO_ANNUAL_V3_1: "v3.1-pro-annual",
  PRO_ANNUAL_V3_2: "v3.2-pro-annual",
  PRO_ANNUAL_V3_3: "v3.3-pro-annual",
  PRO_PLUS_MONTHLY_V3_1: "v3.1-pro-plus-monthly",
  PRO_PLUS_MONTHLY_V3_2: "v3.2-pro-plus-monthly",
  PRO_PLUS_MONTHLY_V3_3: "v3.3-pro-plus-monthly",
  PRO_PLUS_ANNUAL_V3_1: "v3.1-pro-plus-annual",
  PRO_PLUS_ANNUAL_V3_2: "v3.2-pro-plus-annual",
  PRO_PLUS_ANNUAL_V3_3: "v3.3-pro-plus-annual",
  TEAM_ANNUAL_V3_1: "v3.1-team-annual",
  TEAM_ANNUAL_V3_2: "v3.2-team-annual",
  TEAM_ANNUAL_V3_3: "v3.3-team-annual",
  TEAM_MONTHLY_V3_1: "v3.1-team-monthly",
  TEAM_MONTHLY_V3_2: "v3.2-team-monthly",
  TEAM_MONTHLY_V3_3: "v3.3-team-monthly",
  ENTERPRISE_ANNUAL_V3_1: "v3.1-ent-annual",
  ENTERPRISE_ANNUAL_V3_2: "v3.2-ent-annual",
  ENTERPRISE_ANNUAL_V3_3: "v3.3-ent-annual",
  ENTERPRISE_MONTHLY_V3_1: "v3.1-ent-monthly",
  ENTERPRISE_MONTHLY_V3_2: "v3.2-ent-monthly",
  ENTERPRISE_MONTHLY_V3_3: "v3.3-ent-monthly",
};

// Billing Plans Defined from FrontEnd
export const PLAN_NAMES = {
  essentials: "Essentials",
  "team-monthly": "Team",
  "team-annual": "Team",
  "enterprise-monthly": "Enterprise",
  "enterprise-annual": "Enterprise",
  // NEW PLANS NAMES
  basic: "Basic",
  "pro-plus-monthly": "Pro Plus",
  "pro-plus-annual": "Pro Plus",
  "pro-monthly": "Pro",
  "pro-annual": "Pro",
  "v3-team-annual": "Team",
  "v3-team-monthly": "Team",
  "v3-ent-annual": "Enterprise",
  "v3-ent-monthly": "Enterprise",
  "v3.1-basic": "Basic",
  "v3.2-basic": "Basic",
  "v3.3-basic": "Basic",
  "v3.1-pro-monthly": "Pro",
  "v3.2-pro-monthly": "Pro",
  "v3.3-pro-monthly": "Pro",
  "v3.1-pro-annual": "Pro",
  "v3.2-pro-annual": "Pro",
  "v3.3-pro-annual": "Pro",
  "v3.1-pro-plus-monthly": "Pro Plus",
  "v3.2-pro-plus-monthly": "Pro Plus",
  "v3.3-pro-plus-monthly": "Pro Plus",
  "v3.1-pro-plus-annual": "Pro Plus",
  "v3.2-pro-plus-annual": "Pro Plus",
  "v3.3-pro-plus-annual": "Pro Plus",
  "v3.1-team-annual": "Team",
  "v3.2-team-annual": "Team",
  "v3.3-team-annual": "Team",
  "v3.1-team-monthly": "Team",
  "v3.2-team-monthly": "Team",
  "v3.3-team-monthly": "Team",
  "v3.1-ent-annual": "Enterprise",
  "v3.2-ent-annual": "Enterprise",
  "v3.3-ent-annual": "Enterprise",
  "v3.1-ent-monthly": "Enterprise",
  "v3.2-ent-monthly": "Enterprise",
  "v3.3-ent-monthly": "Enterprise",
};

const BASIC_V3_DETAILS = {
  title: "Basic",
  includes: [
    "Ready-to-use 400+ templates and forms for you to customize for your business",
    "Create custom templates and forms",
    "Drag-and-Drop eSignatures, sign on any device",
    "Upload PDF & word documents, send for eSign",
    "Collect payments using Stripe",
    "Save unlimited documents securely in a central repository",
    "3 e-Signs free",
    "Upto 2 users",
    "5GB storage",
  ],
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const PRO_PLUS_MONTHLY_V3_INCLUDES = [
  "Premium eSignatures including email alerts and SMS/Text authentication of signers",
  "Advanced repository management with role based document access by clients and groups  ",
  "Machine learning powered document analyzer",
  "Collaboration and approval workflows",
  "Leverage Native API to send documents in batches",
  "50 e-Signs/month free",
  "Upto 50 users",
  "100GB storage",
];

const PRO_MONTHLY_DETAILS_INCLUDES = [
  "Advanced eSignatures including in-app recipient activity tracking",
  "Advanced repository management with role based document access",
  "Metalens powered document data extraction for use by downstream apps",
  "Bring in pricing, inventory, salary and other tabulated information from Google sheets",
  "Connect your documents to other business apps via Zapier",
  "10 e-Signs/month free",
  "Upto 10 users",
  "30GB storage",
];

const PRO_ANNUAL_DETAILS_INCLUDES = [
  "Advanced eSignatures including in-app recipient activity tracking",
  "Advanced repository management with role based document access",
  "Metalens powered document data extraction for use by downstream apps",
  "Bring in pricing, inventory, salary and other tabulated information from Google sheets",
  "Connect your documents to other business apps via Zapier",
  "10 e-Signs/month free",
  "Upto 10 users",
  "30GB storage",
];

const TEAM_V3_INCLUDES = [];

const ENTERPRISE_V3_INCLUDES = [
  "Custom dashboards & reports",
  "CRM Integration",
  "Templates with custom variables",
  "Redlining (coming soon)",
  "Audio notes (coming soon)",
];

const PRO_MONTHLY_DETAILS = {
  title: "Pro (Monthly)",
  includes: PRO_MONTHLY_DETAILS_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const PRO_ANNUAL_DETAILS = {
  title: "Pro (Annual)",
  includes: PRO_ANNUAL_DETAILS_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const PRO_PLUS_MONTHLY_DETAILS = {
  title: "Pro Plus (Monthly)",
  includes: PRO_PLUS_MONTHLY_V3_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const PRO_PLUS_ANNUAL_DETAILS = {
  title: "Pro Plus (Annual)",
  includes: PRO_PLUS_MONTHLY_V3_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const TEAM_MONTHLY_DETAILS = {
  title: "Team (Monthly)",
  includes: TEAM_V3_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const TEAM_ANNUAL_DETAILS = {
  title: "Team (Annual)",
  includes: TEAM_V3_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const ENTERPRISE_MONTHLY_DETAILS = {
  title: "Enterprise (Monthly)",
  includes: ENTERPRISE_V3_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

const ENTERPRISE_ANNUAL_DETAILS = {
  title: "Enterprise (Annual)",
  includes: ENTERPRISE_V3_INCLUDES,
  contactTxt:
    "To unlock more features and upgrade, contact your account owner ",
};

// Full Context based on billing plans
export const NON_ADMIN_BILLING_CONTEXT = {
  [BILLING_PLANS.ESSENTIALS]: {
    title: "Essentials",
    includes: [
      "Unlimited document creation",
      "Unlimited free templates",
      "Upto 10 users",
      "10 eSignatures per month ",
      "3 approval workflows ",
      "Unlimited link sharing and all collaboration features",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.TEAM_MONTHLY]: {
    title: "Team - Monthly",
    includes: [
      "Unlimited document creation",
      "Unlimited free templates",
      "Upto 50 users",
      "Unlimited e-signatures",
      "Unlimited approval workflows ",
      "Unlimited price books",
      "Unlimited link sharing and all collaboration features",
      "Insights dashboard",
    ],
    contactTxt: "To change your plan, contact your account owner ",
  },
  [BILLING_PLANS.TEAM_ANNUAL]: {
    title: "Team - Annual",
    includes: [
      "Unlimited document creation",
      "Unlimited free templates",
      "Upto 50 users",
      "Unlimited e-signatures",
      "Unlimited approval workflows ",
      "Unlimited price books",
      "Unlimited link sharing and all collaboration features",
      "Insights dashboard",
    ],
    contactTxt: "To change your plan, contact your account owner ",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY]: {
    title: "Enterprise - Monthly",
    includes: [
      "Custom dashboards & reports",
      "CRM Integration",
      "Templates with custom variables",
      "Redlining (coming soon)",
      "Audio notes (coming soon)",
    ],
    contactTxt: "To change your plan, contact your account owner ",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL]: {
    title: "Enterprise - Annual",
    includes: [
      "Custom dashboards & reports",
      "CRM Integration",
      "Templates with custom variables",
      "Redlining (coming soon)",
      "Audio notes (coming soon)",
    ],
    contactTxt: "To change your plan, contact your account owner ",
  },
  // NEW PLAN MAPPING
  [BILLING_PLANS.BASIC]: {
    title: "Basic",
    includes: [
      "Unlimited users",
      "Unlimited documents",
      "5 active templates",
      "5 E-signs/month Free",
      "5GB Storage",
      "Google Sheet, Zapier Integration(1000+ apps)",
      "Machine learning based document analysis",
      "Rich media drag-n-drop editor",
      "Full access to Template Store",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_PLUS_MONTHLY]: {
    title: "Pro Plus (Monthly)",
    includes: [
      "Premium eSignatures including email alerts and SMS/Text authentication of signers",
      "Advanced repository management with role based document access by clients and groups  ",
      "Machine learning powered document analyzer",
      "Collaboration and approval workflows",
      "Leverage Native API to send documents in batches",
      "50 e-Signs/month free",
      "Upto 50 users",
      "100GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_PLUS_ANNUAL]: {
    title: "Pro Plus (Annual)",
    includes: [
      "Premium eSignatures including email alerts and SMS/Text authentication of signers",
      "Advanced repository management with role based document access by clients and groups  ",
      "Machine learning powered document analyzer",
      "Collaboration and approval workflows",
      "Leverage Native API to send documents in batches",
      "50 e-Signs/month free",
      "Upto 50 users",
      "100GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_MONTHLY]: {
    title: "Pro (Monthly)",
    includes: [
      "Advanced eSignatures including in-app recipient activity tracking",
      "Advanced repository management with role based document access",
      "Metalens powered document data extraction for use by downstream apps",
      "Bring in pricing, inventory, salary and other tabulated information from Google sheets",
      "Connect your documents to other business apps via Zapier",
      "10 e-Signs/month free",
      "Upto 10 users",
      "30GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_ANNUAL]: {
    title: "Pro (Annual)",
    includes: [
      "Advanced eSignatures including in-app recipient activity tracking",
      "Advanced repository management with role based document access",
      "Metalens powered document data extraction for use by downstream apps",
      "Bring in pricing, inventory, salary and other tabulated information from Google sheets",
      "Connect your documents to other business apps via Zapier",
      "10 e-Signs/month free",
      "Upto 10 users",
      "30GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.TEAM_ANNUAL_V3]: {
    title: "Team - Annual",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.TEAM_MONTHLY_V3]: {
    title: "Team - Monthly",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3]: {
    title: "Enterprise - Annual",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3]: {
    title: "Enterprise - Monthly",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  // NEW BILLING PLANS V[3.1 - 3.3]
  [BILLING_PLANS.BASIC_V3_1]: BASIC_V3_DETAILS,
  [BILLING_PLANS.BASIC_V3_2]: BASIC_V3_DETAILS,
  [BILLING_PLANS.BASIC_V3_3]: BASIC_V3_DETAILS,
  [BILLING_PLANS.PRO_MONTHLY_V3_1]: PRO_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_MONTHLY_V3_2]: PRO_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_MONTHLY_V3_3]: PRO_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_ANNUAL_V3_1]: PRO_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_ANNUAL_V3_2]: PRO_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_ANNUAL_V3_3]: PRO_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_1]: PRO_PLUS_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_2]: PRO_PLUS_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_3]: PRO_PLUS_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_1]: PRO_PLUS_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_2]: PRO_PLUS_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_3]: PRO_PLUS_ANNUAL_DETAILS,
  [BILLING_PLANS.TEAM_MONTHLY_V3_1]: TEAM_MONTHLY_DETAILS,
  [BILLING_PLANS.TEAM_MONTHLY_V3_2]: TEAM_MONTHLY_DETAILS,
  [BILLING_PLANS.TEAM_MONTHLY_V3_3]: TEAM_MONTHLY_DETAILS,
  [BILLING_PLANS.TEAM_ANNUAL_V3_1]: TEAM_ANNUAL_DETAILS,
  [BILLING_PLANS.TEAM_ANNUAL_V3_2]: TEAM_ANNUAL_DETAILS,
  [BILLING_PLANS.TEAM_ANNUAL_V3_3]: TEAM_ANNUAL_DETAILS,
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_1]: ENTERPRISE_MONTHLY_DETAILS,
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_2]: ENTERPRISE_MONTHLY_DETAILS,
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_3]: ENTERPRISE_MONTHLY_DETAILS,
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_1]: ENTERPRISE_ANNUAL_DETAILS,
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_2]: ENTERPRISE_ANNUAL_DETAILS,
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_3]: ENTERPRISE_ANNUAL_DETAILS,
};

export const BILLING_CONTEXT = {
  [BILLING_PLANS.ESSENTIALS]: {
    title: "Essentials",
    description:
      "Business in a box solution for individuals or small teams to remove distractions from running your core business.",
    includes: [
      "Unlimited document creation",
      "Unlimited free templates",
      "Upto 10 users",
      "10 eSignatures per month",
      "3 approval workflows",
      "Unlimited link sharing and all collaboration features",
    ],
    upsale: {
      title:
        "Expanding your team or looking to manage quote generation better? Upgrade to the Team or Enterprise plan",
      contents: [
        "Unlimited Price Books",
        "Unlimited eSignatures",
        "Unlimited Workflows",
        "Insights Dashboard",
        "Upto 50 users",
      ],
      btnType: "upgrade",
      btnTxt: "Upgrade to team plan",
    },
  },
  [BILLING_PLANS.TEAM_MONTHLY]: {
    title: "Team - Monthly",
    description:
      "Fast growing or distributed teams that need smarter collaboration and faster turnarounds.",
    includes: [
      "Upto 50 users",
      "Unlimited documents",
      "Custom templates",
      "Unlimited eSignatures",
      "Unlimited workflows",
      "Unlimited price books",
      "Insights dashboard",
    ],
    upsale: {
      title:
        "Looking for custom integrations and premium support for your enterprise? Upgrade to the Enterprise plan",
      contents: [
        "Custom dashboards & reports",
        "CRM Integration",
        "Templates with custom variables",
        "Redlining (coming soon)",
        "Audio notes (coming soon)",
      ],
      btnType: "contact",
      btnTxt: "Get in touch with us",
    },
    nxtPlan: BILLING_PLANS.ENTERPRISE_MONTHLY,
    prevPlan: BILLING_PLANS.ESSENTIALS,
  },
  [BILLING_PLANS.TEAM_ANNUAL]: {
    title: "Team - Annual",
    description:
      "Fast growing or distributed teams that need smarter collaboration and faster turnarounds.",
    includes: [
      "Upto 50 users",
      "Unlimited documents",
      "Custom templates",
      "Unlimited eSignatures",
      "Unlimited workflows",
      "Unlimited price books",
      "Insights dashboard",
    ],
    upsale: {
      title:
        "Looking for custom integrations and premium support for your enterprise? Upgrade to the Enterprise plan",
      contents: [
        "Custom dashboards & reports",
        "CRM Integration",
        "Templates with custom variables",
        "Redlining (coming soon)",
        "Audio notes (coming soon)",
      ],
      btnType: "contact",
      btnTxt: "Get in touch with us",
    },
    nxtPlan: BILLING_PLANS.ENTERPRISE_ANNUAL,
    prevPlan: BILLING_PLANS.ESSENTIALS,
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY]: {
    title: "Enterprise - Monthly",
    description:
      "For companies that need insights driven document management, advanced security and custom integrations",
    includes: [
      "Custom dashboards & reports",
      "CRM Integration",
      "Templates with custom variables",
      "Redlining (coming soon)",
      "Audio notes (coming soon)",
    ],
    upsale: {
      title: "Help and Support",
    },
    prevPlan: BILLING_PLANS.TEAM_MONTHLY,
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL]: {
    title: "Enterprise - Annual",
    description:
      "For companies that need insights driven document management, advanced security and custom integrations",
    includes: [
      "Custom dashboards & reports",
      "CRM Integration",
      "Templates with custom variables",
      "Redlining (coming soon)",
      "Audio notes (coming soon)",
    ],
    upsale: {
      title: "Help and Support",
    },
    prevPlan: BILLING_PLANS.TEAM_ANNUAL,
  },
  // NEW PLAN MAPPING
  [BILLING_PLANS.BASIC]: {
    title: "Basic",
    includes: [
      "Unlimited users",
      "Unlimited documents",
      "5 active templates",
      "5 E-signs/month Free",
      "5GB Storage",
      "Google Sheet, Zapier Integration(1000+ apps)",
      "Machine learning based document analysis",
      "Rich media drag-n-drop editor",
      "Full access to Template Store",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_PLUS_MONTHLY]: {
    title: "Pro Plus (Monthly)",
    includes: [
      "Premium eSignatures including email alerts and SMS/Text authentication of signers",
      "Advanced repository management with role based document access by clients and groups  ",
      "Machine learning powered document analyzer",
      "Collaboration and approval workflows",
      "Leverage Native API to send documents in batches",
      "50 e-Signs/month free",
      "Upto 50 users",
      "100GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_PLUS_ANNUAL]: {
    title: "Pro Plus (Annual)",
    includes: [
      "Premium eSignatures including email alerts and SMS/Text authentication of signers",
      "Advanced repository management with role based document access by clients and groups  ",
      "Machine learning powered document analyzer",
      "Collaboration and approval workflows",
      "Leverage Native API to send documents in batches",
      "50 e-Signs/month free",
      "Upto 50 users",
      "100GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_MONTHLY]: {
    title: "Pro (Monthly)",
    includes: [
      "Advanced eSignatures including in-app recipient activity tracking",
      "Advanced repository management with role based document access",
      "Metalens powered document data extraction for use by downstream apps",
      "Bring in pricing, inventory, salary and other tabulated information from Google sheets",
      "Connect your documents to other business apps via Zapier",
      "10 e-Signs/month free",
      "Upto 10 users",
      "30GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.PRO_ANNUAL]: {
    title: "Pro (Annual)",
    includes: [
      "Advanced eSignatures including in-app recipient activity tracking",
      "Advanced repository management with role based document access",
      "Metalens powered document data extraction for use by downstream apps",
      "Bring in pricing, inventory, salary and other tabulated information from Google sheets",
      "Connect your documents to other business apps via Zapier",
      "10 e-Signs/month free",
      "Upto 10 users",
      "30GB storage",
    ],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.TEAM_ANNUAL_V3]: {
    title: "Team - Annual",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.TEAM_MONTHLY_V3]: {
    title: "Team - Monthly",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3]: {
    title: "Enterprise - Annual",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3]: {
    title: "Enterprise - Monthly",
    includes: [],
    contactTxt:
      "To unlock more features and upgrade, contact your account owner ",
  },
  // NEW BILLING PLANS V[3.1 - 3.3]
  [BILLING_PLANS.BASIC_V3_1]: BASIC_V3_DETAILS,
  [BILLING_PLANS.BASIC_V3_2]: BASIC_V3_DETAILS,
  [BILLING_PLANS.BASIC_V3_3]: BASIC_V3_DETAILS,
  [BILLING_PLANS.PRO_MONTHLY_V3_1]: PRO_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_MONTHLY_V3_2]: PRO_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_MONTHLY_V3_3]: PRO_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_ANNUAL_V3_1]: PRO_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_ANNUAL_V3_2]: PRO_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_ANNUAL_V3_3]: PRO_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_1]: PRO_PLUS_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_2]: PRO_PLUS_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_3]: PRO_PLUS_MONTHLY_DETAILS,
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_1]: PRO_PLUS_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_2]: PRO_PLUS_ANNUAL_DETAILS,
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_3]: PRO_PLUS_ANNUAL_DETAILS,
  [BILLING_PLANS.TEAM_MONTHLY_V3_1]: TEAM_MONTHLY_DETAILS,
  [BILLING_PLANS.TEAM_MONTHLY_V3_2]: TEAM_MONTHLY_DETAILS,
  [BILLING_PLANS.TEAM_MONTHLY_V3_3]: TEAM_MONTHLY_DETAILS,
  [BILLING_PLANS.TEAM_ANNUAL_V3_1]: TEAM_ANNUAL_DETAILS,
  [BILLING_PLANS.TEAM_ANNUAL_V3_2]: TEAM_ANNUAL_DETAILS,
  [BILLING_PLANS.TEAM_ANNUAL_V3_3]: TEAM_ANNUAL_DETAILS,
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_1]: ENTERPRISE_MONTHLY_DETAILS,
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_2]: ENTERPRISE_MONTHLY_DETAILS,
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_3]: ENTERPRISE_MONTHLY_DETAILS,
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_1]: ENTERPRISE_ANNUAL_DETAILS,
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_2]: ENTERPRISE_ANNUAL_DETAILS,
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_3]: ENTERPRISE_ANNUAL_DETAILS,
};

// :: UPGRADE PLAN PAGE RELATED CONSTANTS

// Plan Execution based on the current plan & condition for upgradePlan.js ==> in future (needs to remove)
export const BILLING_CONTEXT_FOR_UPGRADE_PAGE = {
  [BILLING_PLANS.ESSENTIALS]: {
    possiblePlanContext: {
      type: "upgrade",
      newPlan: BILLING_PLANS.ENTERPRISE_MONTHLY,
    },
  },
  [BILLING_PLANS.TEAM_MONTHLY]: {
    possiblePlanContext: {
      type: "upgrade",
      newPlan: BILLING_PLANS.ENTERPRISE_MONTHLY,
    },
  },
  [BILLING_PLANS.TEAM_ANNUAL]: {
    possiblePlanContext: {
      type: "upgrade",
      newPlan: BILLING_PLANS.ENTERPRISE_ANNUAL,
    },
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY]: {
    possiblePlanContext: {
      type: "downgrade",
      newPlan: BILLING_PLANS.TEAM_MONTHLY,
    },
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL]: {
    possiblePlanContext: {
      type: "downgrade",
      newPlan: BILLING_PLANS.TEAM_ANNUAL,
    },
  },
};

// Button label handling based on the team plan in UpgradePlan.js ==> (in future (needs to remove)
export const TEAM_PLAN_BUTTON_CONTROL = {
  [BILLING_PLANS.TEAM_ANNUAL]: {
    expectedButtonLabel: "Change to team - Monthly",
  },
  [BILLING_PLANS.TEAM_MONTHLY]: {
    expectedButtonLabel: "Change to team - Annualy",
  },
};

// Text which will be imported in UpgradePlan.js
export const UPGRADEPLAN_SETTINGS = {
  UPGRADEPLAN_HEADINGS: "What's the best plan for you?",
};

export const STRIPE_BUTTON_CONTROL = {
  FREE_TRIAL: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    // here message has been handled in CurrentPlan component inside _getStripeMessage function call. if need to change please refer there
    message: "",
  },
  BASIC_DOWNGRADED: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    message:
      "Your free trial of Revv has ended. You have been moved to the free plan with limited features. Browse our affordable pricing plans and upgrade now to make the most of Revv.",
  },
  CANCELLED: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message: "Your subscription has ended. Please contact us for renewal.",
  },
  [BILLING_PLANS.BASIC]: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    message:
      "You are currently on our Basic (free) plan. Browse our affordable pricing plans and Upgrade now to keep your business moving upward.",
  },
  [BILLING_PLANS.BASIC_V3_1]: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    message:
      "You are currently on our Basic (free) plan. Browse our affordable pricing plans and Upgrade now to keep your business moving upward.",
  },
  [BILLING_PLANS.BASIC_V3_2]: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    message:
      "You are currently on our Basic (free) plan. Browse our affordable pricing plans and Upgrade now to keep your business moving upward.",
  },
  [BILLING_PLANS.BASIC_V3_3]: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    message:
      "You are currently on our Basic (free) plan. Browse our affordable pricing plans and Upgrade now to keep your business moving upward.",
  },
  [BILLING_PLANS.PRO_MONTHLY]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (monthly) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_MONTHLY_V3_1]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (monthly) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_MONTHLY_V3_2]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (monthly) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_MONTHLY_V3_3]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (monthly) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_ANNUAL]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_ANNUAL_V3_1]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_ANNUAL_V3_2]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_ANNUAL_V3_3]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_MONTHLY]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to (monthly) Revv's Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_1]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to (monthly) Revv's Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_2]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to (monthly) Revv's Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_MONTHLY_V3_3]: {
    buttons: [
      // { buttonLabel: "Upgrade", id: "Upgrade" },
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to (monthly) Revv's Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_ANNUAL]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_1]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_2]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.PRO_PLUS_ANNUAL_V3_3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You are currently subscribed to Revv's (annual) Pro plus plan that comes with a quota of eSignatures and users. If you'd like to buy more eSignatures or add more users, get in touch with us for the best deal.",
  },
  [BILLING_PLANS.ESSENTIALS]: {
    buttons: [
      {
        buttonLabel: "Upgrade now",
        id: "Subscribe",
        className: "currentplan-details-contactus",
      },
    ],
    message:
      "You are currently on the (free) Essentials plan of Revv. Browse our affordable pricing plans and Upgrade now to keep your business moving upward.",
  },
  [BILLING_PLANS.TEAM_MONTHLY]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_MONTHLY_V3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_MONTHLY_V3_1]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_MONTHLY_V3_2]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_MONTHLY_V3_3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_ANNUAL]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_ANNUAL_V3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_ANNUAL_V3_1]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_ANNUAL_V3_2]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.TEAM_ANNUAL_V3_3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_1]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_2]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL_V3_3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_1]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_2]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY_V3_3]: {
    buttons: [
      {
        buttonLabel: "Contact us",
        id: "Contact us",
        className: "currentplan-details-contactus revv-btn-secondary",
      },
    ],
    message:
      "You're currently subscribed to a Revv plan customized just for you.  If you'd like to buy more eSignatures, add more users or upgrade get in touch with us for the best deal. .",
  },
};

export const PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION = {
  monthly: [
    {
      displayName: "Pro",
      planName: BILLING_PLANS.PRO_MONTHLY,
      planPrice: "$19",
      yearlyPrice: "$228/year",
      buttonLabel: "Subscribe to Pro",
      featureEnabled: PRO_MONTHLY_DETAILS_INCLUDES,
      mostPopular: false,
      priceID: "revv-v3.1-pro-monthly",
    },
    {
      displayName: "Pro Plus",
      planName: BILLING_PLANS.PRO_PLUS_MONTHLY,
      planPrice: "$59",
      yearlyPrice: "$708/year",
      buttonLabel: "Subscribe to Pro Plus",
      featureEnabled: PRO_PLUS_MONTHLY_V3_INCLUDES,
      mostPopular: true,
      priceID: "revv-v3.1-pro-plus-monthly",
    },
  ],
  annually: [
    {
      displayName: "Pro",
      planName: BILLING_PLANS.PRO_ANNUAL,
      planPrice: "$15",
      yearlyPrice: "$180 billed annually",
      buttonLabel: "Subscribe to Pro",
      featureEnabled: PRO_ANNUAL_DETAILS_INCLUDES,
      mostPopular: false,
      priceID: "revv-v3.1-pro-annual",
    },
    {
      displayName: "Pro Plus",
      planName: BILLING_PLANS.PRO_PLUS_ANNUAL,
      planPrice: "$49",
      yearlyPrice: "$588 billed annually",
      buttonLabel: "Subscribe to Pro Plus",
      featureEnabled: PRO_PLUS_MONTHLY_V3_INCLUDES,
      mostPopular: true,
      priceID: "revv-v3.1-pro-plus-annual",
    },
  ],
};

// PRICING_PLAN_MENU which will be imported in UpgradePlan.js ,Please don't change order  ==> (in future (needs to remove)
export const PRICING_PLAN_MENU = {
  Essentials: {
    id: 1,
    displayName: "Essentials",
    planName: "Essentials",
    planDescription:
      "Business in a box solution for individuals or small teams to remove distractions from running your core business.",
    planPrice: "Free",
    planSubheading: "",
    priceCurrency: "",
    buttonLabel: "Current Plan",
    buttonStatus: true,
    className: "",
    showMostPopularBox: false,
    featureHeader: "",
    featureEnabled: [
      "Unlimited document creation",
      "Unlimited free templates",
      "Upto 10 users",
      "10 eSignatures per month, included",
      "3 approval workflows",
      "Unlimited link sharing and all collaboration features",
    ],
  },
  Team: {
    id: 2,
    displayName: "Teams",
    planName: "Team",
    planDescription:
      "Fast growing or distributed teams that need smarter collaboration and faster turnarounds.",
    planPrice: 49,
    planSubheading: "Per month",
    priceCurrency: "$",
    buttonLabel: "Get in touch with us",
    buttonStatus: false,
    className: "upgrade-plan-team-card",
    showMostPopularBox: true,
    featureHeader: "All the Essentials plan features plus",
    featureEnabled: [
      "Unlimited eSignatures",
      "Upto 50 users",
      "Unlimited workflows",
      "Unlimited price books",
      "Insights dashboard",
    ],
  },
  Enterprise: {
    id: 3,
    displayName: "Enterprise",
    planName: "Enterprise",
    planDescription:
      "For companies that need insights driven document management, advanced security and custom integrations maybe we can use that for now",
    planPrice: "Custom",
    planSubheading: "",
    priceCurrency: "",
    buttonLabel: "Get in touch with us",
    buttonStatus: false,
    className: "",
    showMostPopularBox: false,
    featureHeader: "All the Team plan features plus",
    featureEnabled: [
      "Custom dashboards & reports",
      "CRM Integration",
      "Custom branding",
      "Custom templates",
      "Redlining (coming soon)",
      "Audio notes (coming soon)",
    ],
  },
};

export const COLUMN_DEFINATION = [
  {
    id: "COL1",
    bindToProperty: "featureName",
    label: "Features",
  },
  {
    id: "COL2",
    bindToProperty: "essentials",
    label: "Essential",
  },
  {
    id: "COL3",
    bindToProperty: "teams",
    label: "Team",
  },
  {
    id: "COL4",
    bindToProperty: "enterprise",
    label: "Enterprise",
  },
];

export const EXCLUDE_QUOTE_TABLE_PLANS = [
  BILLING_PLANS.BASIC,
  BILLING_PLANS.PRO_PLUS_MONTHLY,
  BILLING_PLANS.PRO_PLUS_ANNUAL,
  BILLING_PLANS.BASIC_V3_1,
  BILLING_PLANS.BASIC_V3_2,
  BILLING_PLANS.BASIC_V3_3,
  BILLING_PLANS.PRO_PLUS_MONTHLY_V3_1,
  BILLING_PLANS.PRO_PLUS_MONTHLY_V3_2,
  BILLING_PLANS.PRO_PLUS_MONTHLY_V3_3,
  BILLING_PLANS.PRO_PLUS_ANNUAL_V3_1,
  BILLING_PLANS.PRO_PLUS_ANNUAL_V3_2,
  BILLING_PLANS.PRO_PLUS_ANNUAL_V3_3,
  BILLING_PLANS.PRO_MONTHLY_V3_1,
  BILLING_PLANS.PRO_MONTHLY_V3_2,
  BILLING_PLANS.PRO_MONTHLY_V3_3,
  BILLING_PLANS.PRO_ANNUAL_V3_1,
  BILLING_PLANS.PRO_ANNUAL_V3_2,
  BILLING_PLANS.PRO_ANNUAL_V3_3,
];

export const ROW_DATA_CONFIG = [
  {
    groupId: 1,
    groupName: "Support",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Knowledge Base",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "24x7 email support",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "24x7 chat support",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "24x5 phone support",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 2,
    groupName: "Document",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "e-Signature",
          additionalValue: "",
        },
        essentials: {
          type: "LABEL",
          value: "10 Signatures",
          additionalValue: "plan-comparison-value-margin",
        },
        teams: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
        enterprise: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Rich document editor",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "In-document comments",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Document status tracking",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Unlimited storage",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 6,
        featureName: {
          type: "LABEL",
          value: "Content locking",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 7,
        featureName: {
          type: "LABEL",
          value: "Custom branding *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 8,
        featureName: {
          type: "LABEL",
          value: "Third-party paper upload",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 9,
        featureName: {
          type: "LABEL",
          value: "Revision management *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 3,
    groupName: "Templates",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Versatile library of templates",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Create custom templates",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Standard variables in templates",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Clause options in templates",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Custom variables in templates",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 4,
    groupName: "Quoting",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Price Book",
          additionalValue: "",
        },
        essentials: {
          type: "LABEL",
          value: "1",
          additionalValue: "plan-comparison-value-margin",
        },
        teams: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
        enterprise: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Product catalog",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Multi-level discounts",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Custom columns in price book",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Range/Tiered Pricing",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 6,
        featureName: {
          type: "LABEL",
          value: "Multi currency",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 7,
        featureName: {
          type: "LABEL",
          value: "On demand pricing (DIY Pricing)",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 8,
        featureName: {
          type: "LABEL",
          value: "Bundle pricing",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 9,
        featureName: {
          type: "LABEL",
          value: "Product - Bundle",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 5,
    groupName: "Document Sharing",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Document collaboration via link",
          additionalValue: "",
        },
        essentials: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
        teams: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
        enterprise: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Export to PDF (.pdf)",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Real-time tracking and notifications *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Export to MS Word (.docx)",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Interactive document *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 6,
        featureName: {
          type: "LABEL",
          value: "Audio notes *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 6,
    groupName: "Document Organization",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Document tagging *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Content and image library *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Document search *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 7,
    groupName: "Analytics",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Standard dashboard",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Export reporting data *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Template specific analytics *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Document search *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 8,
    groupName: "Actionable insights",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Email notifications",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "In-app notifications",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Document status tracking",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Audit trail *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Renewal notifications *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 9,
    groupName: "Integrations",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Salesforce standard",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Zoho",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "HubSpot *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Zendesk Sell *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Freshsales *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 6,
        featureName: {
          type: "LABEL",
          value: "Pipedrive *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 7,
        featureName: {
          type: "LABEL",
          value: "Copper *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 8,
        featureName: {
          type: "LABEL",
          value: "Insightly *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 9,
        featureName: {
          type: "LABEL",
          value: "Microsoft dynamics *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 10,
        featureName: {
          type: "LABEL",
          value: "Nimble *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 11,
        featureName: {
          type: "LABEL",
          value: "Close *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 12,
        featureName: {
          type: "LABEL",
          value: "SugarCRM *",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 13,
        featureName: {
          type: "LABEL",
          value: "Salesforce custom",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  {
    groupId: 10,
    groupName: "Workflows and Controls",
    rowData: [
      {
        rowId: 1,
        featureName: {
          type: "LABEL",
          value: "Conditional workflows (Standard Variables)",
          additionalValue: "",
        },
        essentials: {
          type: "LABEL",
          value: "3 Workflows",
          additionalValue: "plan-comparison-value-margin",
        },
        teams: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
        enterprise: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
      },
      {
        rowId: 2,
        featureName: {
          type: "LABEL",
          value: "Deal table workflow",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
        enterprise: {
          type: "LABEL",
          value: "Unlimited",
          additionalValue: "plan-comparison-value-margin",
        },
      },
      {
        rowId: 3,
        featureName: {
          type: "LABEL",
          value: "Approver addition",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 4,
        featureName: {
          type: "LABEL",
          value: "Approval order",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 5,
        featureName: {
          type: "LABEL",
          value: "Approver groups",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
      {
        rowId: 6,
        featureName: {
          type: "LABEL",
          value: "Conditional workflows (Clause Options)",
          additionalValue: "",
        },
        essentials: {
          type: "SYMBOL",
          value: "times-circle",
          additionalValue: "grey",
        },
        teams: {
          type: "LABEL",
          value: "$$",
          additionalValue: "plan-comparison-badge-warning",
        },
        enterprise: {
          type: "SYMBOL",
          value: "check-circle",
          additionalValue: "green",
        },
      },
    ],
  },
  // {
  //   groupId: 11,
  //   groupName: "System",
  //   rowData: [
  //     {
  //       rowId: 1,
  //       featureName: {
  //         type: "LABEL",
  //         value: "User management",
  //         additionalValue: "",
  //       },
  //       essentials: {
  //         type: "LABEL",
  //         value: "10 Users",
  //         additionalValue: "plan-comparison-value-margin",
  //       },
  //       teams: {
  //         type: "LABEL",
  //         value: "50 Users",
  //         additionalValue: "plan-comparison-value-margin",
  //       },
  //       enterprise: {
  //         type: "LABEL",
  //         value: "Unlimited",
  //         additionalValue: "plan-comparison-value-margin",
  //       },
  //     },
  //     {
  //       rowId: 2,
  //       featureName: {
  //         type: "LABEL",
  //         value: "System roles (admin, manager, member)",
  //         additionalValue: "",
  //       },
  //       essentials: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //       teams: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //       enterprise: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //     },
  //     {
  //       rowId: 3,
  //       featureName: {
  //         type: "LABEL",
  //         value: "Custom roles",
  //         additionalValue: "",
  //       },
  //       essentials: {
  //         type: "SYMBOL",
  //         value: "times-circle",
  //         additionalValue: "grey",
  //       },
  //       teams: {
  //         type: "SYMBOL",
  //         value: "times-circle",
  //         additionalValue: "grey",
  //       },
  //       enterprise: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //     },
  //     {
  //       rowId: 4,
  //       featureName: {
  //         type: "LABEL",
  //         value: "SSO",
  //         additionalValue: "",
  //       },
  //       essentials: {
  //         type: "SYMBOL",
  //         value: "times-circle",
  //         additionalValue: "grey",
  //       },
  //       teams: {
  //         type: "SYMBOL",
  //         value: "times-circle",
  //         additionalValue: "grey",
  //       },
  //       enterprise: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //     },
  //   ],
  // },
  // {
  //   groupId: 12,
  //   groupName: "Contact Manager",
  //   rowData: [
  //     {
  //       rowId: 1,
  //       featureName: {
  //         type: "LABEL",
  //         value: "Simple opportunity account manager *",
  //         additionalValue: "",
  //       },
  //       essentials: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //       teams: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //       enterprise: {
  //         type: "SYMBOL",
  //         value: "check-circle",
  //         additionalValue: "green",
  //       },
  //     },
  //   ],
  // },
];

// :: CURRENT & UPGRADE PLAN PAGE COMMON CONSTANTS

export const PLAN_TYPE = {
  UPGRADE: "upgrade",
  DOWNGRADE: "downgrade",
};

export const PLAN_CHANGE_CONTEXT = {
  [BILLING_PLANS.ESSENTIALS]: {
    welcomeMsg: "Thank you for checking out Revv.",
    upsaleMsg:
      "To upgrade your plan or get details of our offerings, share your phone number with us. Or, you could write to us at support@revv.so",
    features: [],
  },
  [BILLING_PLANS.TEAM_MONTHLY]: {
    welcomeMsg: "Thank you for checking out Revv.",
    upsaleMsg:
      "To upgrade your plan or get details of our offerings, share your phone number with us. Or, you could write to us at support@revv.so",
    features: [],
  },
  [BILLING_PLANS.TEAM_ANNUAL]: {
    welcomeMsg: "Thank you for checking out Revv.",
    upsaleMsg:
      "To upgrade your plan or get details of our offerings, share your phone number with us. Or, you could write to us at support@revv.so",
    features: [],
  },
  [BILLING_PLANS.ENTERPRISE_MONTHLY]: {
    welcomeMsg: "Thank you for checking out Revv.",
    upsaleMsg:
      "To upgrade your plan or get details of our offerings, share your phone number with us. Or, you could write to us at support@revv.so",
    features: [],
  },
  [BILLING_PLANS.ENTERPRISE_ANNUAL]: {
    welcomeMsg: "Thank you for checking out Revv.",
    upsaleMsg:
      "To upgrade your plan or get details of our offerings, share your phone number with us. Or, you could write to us at support@revv.so",
    features: [],
  },
};

export const CURRENT_PLAN_CHANGE_CONTEXT_POPUP = {
  welcomeMsg: "Thank you for checking out Revv.",
  upsaleMsg:
    "To upgrade your plan or get details of our offerings, share your phone number with us. Or, you could write to us at support@revv.so",
  features: [],
};

export const CUSTOMERS_ICON = [
  { src: microniclogo, alt: "microniclogo" },
  { src: industryconnectlogo, alt: "industryconnectlogo" },
  { src: moglixlogo, alt: "moglixlogo" },
  { src: tagnos, alt: "tagnos" },
  { src: codeconstructionlogo, alt: "codeconstruction" },
  { src: sproutsolutionlogo, alt: "sproutsolutionlogo" },
];

export const BILLINGS_ENTITY_CONSUMPTION_POINT = {
  E_SIGN: "esignatures",
  USER_LICENCES: "user_licences",
};



// WEBPACK FOOTER //
// ./src/constants/billing.js